// Banner logo shrinks and rises on scroll (GSAP) to its final size (130px desktop / 72px mobile), animating ONLY transforms since animating width would reflow and re-rasterize the image every frame; `transformOrigin: 50% 100%` reproduces the previous geometry so header-transparent.js keeps the same trigger.
(function () {
  var GSAP_SRC = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js";
  var ST_SRC = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js";

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === "true") return resolve();
        existing.addEventListener("load", function () {
          resolve();
        });
        existing.addEventListener("error", reject);
        return;
      }
      var s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.addEventListener("load", function () {
        s.dataset.loaded = "true";
        resolve();
      });
      s.addEventListener("error", reject);
      document.head.appendChild(s);
    });
  }

  function loadGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript(GSAP_SRC).then(function () {
      return loadScript(ST_SRC);
    });
  }

  function initLogo(wrapper) {
    if (wrapper.dataset.bannerLogoBound === "true") return;
    wrapper.dataset.bannerLogoBound = "true";

    var section = wrapper.closest(".section_banner");
    if (!section) return;

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);

    // On mobile the URL bar collapsing changes innerHeight and would refresh mid-animation, so GSAP is told to ignore vertical resizes.
    ScrollTrigger.config({ ignoreMobileResize: true });

    var isMobile = window.innerWidth < 1000;

    gsap.fromTo(
      wrapper,
      { scale: 1, y: 0 },
      {
        // Final width: 72px under 1000px, else 130px, expressed as a scale ratio against the unchanged layout width; offsetWidth ignores transforms so the measure stays right mid-scrub.
        scale: function () {
          var target = window.innerWidth < 1000 ? 72 : 130;
          var layoutWidth = wrapper.offsetWidth;
          return layoutWidth ? target / layoutWidth : 1;
        },
        // -40dvh figé en px au refresh : plus de dépendance à la hauteur
        // dynamique du viewport pendant le scroll.
        y: function () {
          return -0.4 * window.innerHeight;
        },
        ease: "none",
        transformOrigin: "50% 100%",
        force3D: true,
        scrollTrigger: {
          trigger: section,
          start: function () {
            return window.innerWidth < 768 ? "bottom bottom-=15%" : "bottom bottom";
          },
          end: "bottom center",
          // Mobile has no Lenis (smooth-scroll.js bails on coarse pointers), so any scrub smoothing rides on top of the system's own momentum and trails the finger before snapping: `true` locks the logo to the scroll position instead.
          scrub: isMobile ? true : 1,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  function init() {
    var els = document.querySelectorAll("[data-banner-logo]");
    if (!els.length) return;
    // Reduced motion : logo à taille pleine, sans animation.
    if (prefersReducedMotion) return;

    loadGsap()
      .then(function () {
        els.forEach(initLogo);
      })
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Éditeur de thème : re-init au rechargement d'une section.
  document.addEventListener("shopify:section:load", function (event) {
    var els = event.target.querySelectorAll("[data-banner-logo]");
    if (!els.length || prefersReducedMotion) return;
    loadGsap().then(function () {
      els.forEach(initLogo);
    });
  });
})();
